/**
 * Custom Visualization Storage — localStorage CRUD for custom presets.
 */

import { CustomVisualizationPreset } from './types';

const STORAGE_KEY = 'votebeats_custom_visualizations';

/** Load all custom presets from localStorage */
export function loadCustomPresets(): CustomVisualizationPreset[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // Corrupt data — ignore
  }
  return [];
}

/** Save a custom preset (insert or update by id) */
export function saveCustomPreset(preset: CustomVisualizationPreset): void {
  const presets = loadCustomPresets();
  const idx = presets.findIndex(p => p.id === preset.id);
  if (idx >= 0) {
    presets[idx] = { ...preset, updatedAt: Date.now() };
  } else {
    presets.push({ ...preset, createdAt: Date.now(), updatedAt: Date.now() });
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(presets));
}

/** Delete a custom preset by id */
export function deleteCustomPreset(id: string): void {
  const presets = loadCustomPresets().filter(p => p.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(presets));
}
